<template>
    <div>
        <div class="position-relative">
          <!-- shape Hero -->
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-scrum">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white">{{ project.title }}</h1>
                              <p class="lead  text-white">{{ $t('projects.' + $route.params.id + '.description') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        </div>
        <section class="section section-lg mt--100 mb--100">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">{{ project.title }}</h2>
                        <p v-if="project.text1" class="lead">{{ $t('projects.' + $route.params.id + '.text1') }}</p>
                        <p v-if="project.text2">{{ $t('projects.' + $route.params.id + '.text2') }}</p>
                        <p v-if="project.text3">{{ $t('projects.' + $route.params.id + '.text3') }}</p>
                        <div
                          v-if="project.url"
                          class="btn-wrapper">
                          <a
                            :href="project.url"
                            target="_blank"
                            class="btn btn-primary mt-3">
                            {{ $t('project.buttonLink') }}
                          </a>
                        </div>
                        <div class="px-4 mt-5">
                          <img v-lazy="project.src"
                              class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                              style="width: 200px;">
                          <div class="pt-4 text-center">
                              <h5 class="title">
                                <small v-if="project.role" class="h6 text-muted">{{ $t('project.role') }}</small>
                                <span v-if="project.title" class="d-block mb-1">{{ project.role }}</span>
                              </h5>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import projectsData from '../data/projects.js';

export default {
  name: "project",
  computed: {
    project() {
      let grouped = [];
      let index = -1;
      for (let i = 0; i < projectsData.length; i++) {
        if (projectsData[i].slug === this.$route.params.id) {
          return projectsData[i]
        }
      }
    }
  }
};
</script>